/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Flex from '@atlaskit/primitives/components/flex';
import Box from '@atlaskit/primitives/box';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

export const Skeleton = (): React.JSX.Element => {
	return (
		<Box padding="space.200">
			<Stack space="space.200">
				<Flex gap="space.100" alignItems="center">
					<Box xcss={backButton} />
					<Box xcss={headingSkeleton} />
				</Flex>
				<Flex gap="space.100" alignItems="center">
					<Box xcss={titleSkeleton} />
				</Flex>
				<Stack space="space.100" grow="hug">
					<Box xcss={subtitleItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
				</Stack>

				<Stack space="space.100" grow="hug">
					<Box xcss={subtitleItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
				</Stack>
				<Stack space="space.100" grow="hug">
					<Box xcss={subtitleItem} />
					<Box xcss={menuItem} />
				</Stack>
				<Stack space="space.100" grow="hug">
					<Box xcss={subtitleItem} />
					<Box xcss={menuItem} />
					<Box xcss={menuItem} />
				</Stack>
			</Stack>
		</Box>
	);
};

const titleSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	width: token('space.800'),
	height: token('space.400'),
	borderRadius: 'radius.small',
});

const backButton = xcss({
	backgroundColor: 'color.skeleton',
	width: token('space.400'),
	height: token('space.400'),
	borderRadius: 'radius.small',
});

const headingSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.400'),
	borderRadius: 'radius.small',
	flex: 1,
});

const menuItem = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.300'),
	borderRadius: 'radius.small',
});

const subtitleItem = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.200'),
	width: token('space.1000'),
	borderRadius: 'radius.small',
});
